import { apiHelper } from '@/utils/api.helper'

export const PURCHASE = {
  getCart,
  editCart,
  deleteCartItem,
  getDeliverySlot,
  placeOrder,
  getShipping,
  redeemPoint,
  editDeliveryAddress,
  editBillingAddress,
  changeVolumeVariation
}

const URL = {
  PURCHASE: 'purchase',
  EDIT_CART: 'editcart',
  DELETE_ITEMS: 'deleteitems',
  SCHEDULE: 'schedule',
  PLACE_ORDER: 'placeorder',
  SHIPPING: 'shipping',
  POINT_REDEEM: 'pointredeem',
  EDIT_DELIVERY_ADDRESS: 'editdeliveryaddress',
  EDIT_BILLING_ADDRESS: 'editbillingaddress',
  CHANGE_VOLUME_VARIATION: 'changevolumevariation'
}

function getCart() {
  return apiHelper().post(`${URL.PURCHASE}/${URL.EDIT_CART}`)
}

function editCart(data) {
  const requestBody = {
    product: data
  }

  return apiHelper().post(`${URL.PURCHASE}/${URL.EDIT_CART}`, null, {
    params: requestBody
  })
}

function deleteCartItem(requestBody) {
  return apiHelper().delete(`${URL.PURCHASE}/${URL.DELETE_ITEMS}`, {
    params: requestBody
  })
}

function changeVolumeVariation(requestBody) {
  return apiHelper().put(`${URL.PURCHASE}/${URL.CHANGE_VOLUME_VARIATION}`, null, {
    params: requestBody
  })
}

function getDeliverySlot(data) {
  const requestBody = {
    date: data
  }

  return apiHelper().get(`${URL.PURCHASE}/${URL.SCHEDULE}`, {
    params: requestBody
  })
}

function placeOrder(data) {
  const requestBody = {
    date: data.date,
    time: data.time
  }

  return apiHelper().post(`${URL.PURCHASE}/${URL.PLACE_ORDER}`, null, {
    params: requestBody
  })
}

function getShipping() {
  return apiHelper().get(`${URL.PURCHASE}/${URL.SHIPPING}`)
}

function redeemPoint(data) {
  return apiHelper().post(`${URL.PURCHASE}/${URL.POINT_REDEEM}`, null, {
    params: data
  })
}

function editDeliveryAddress(data) {
  return apiHelper().put(`${URL.PURCHASE}/${URL.EDIT_DELIVERY_ADDRESS}`, null, {
    params: data
  })
}

function editBillingAddress(data) {
  return apiHelper().put(`${URL.PURCHASE}/${URL.EDIT_BILLING_ADDRESS}`, null, {
    params: data
  })
}
